/* @flow */

export const AUTO_RESOLVE_ID = 'auto-resolve';
